<template>
  <router-link
    :to="isLoading ? '#' : { name: 'Item', params: { item: item.id } }"
    style="color: inherit;"
  >
    <article class="media item-container is-relative">
      <figure class="media-left image">
        <div class="ribbon ribbon-top-left" v-if="item.readyForSaleDate > 0">
          <span>{{ $t("home.widget.box.readyForSale") }}</span>
        </div>

        <template v-if="!isLoading">
          <img
            @error="errorImage"
            v-if="item.thumbnail && item.thumbnail.url"
            :realsrc="
              mediaPathResized(item.thumbnail.url, {
                width: 900,
                quality: 75
              })
            "
            :src="
              mediaPathResized(item.thumbnail.url, {
                width: 900,
                quality: 75
              })
            "
          />
          <img
            v-else-if="item.images && item.images[0]"
            @error="errorImage"
            :realsrc="
              mediaPathResized(item.images[0].url, {
                width: 900,
                quality: 75
              })
            "
            :src="
              mediaPathResized(item.images[0].url, {
                width: 900,
                quality: 75
              })
            "
          />
          <img v-else src="https://media.stadssalg.no/404.png" />
        </template>
        <b-skeleton :active="isLoading"></b-skeleton>
      </figure>
      <div class="media-content pl-0 has-text-left is-ellipsis mt-1">
        <div class="content">
          <div class="is-size-7">
            <template v-if="!isLoading">
              {{ item.location ? item.location : "" }}
            </template>
            <b-skeleton :active="isLoading" width="5em"></b-skeleton>
          </div>

          <template v-if="!isLoading">
            <p class="is-ellipsis" v-if="item.title">
              {{ item.title }}
            </p>
            <p v-else>{{ $t("home.widget.box.noName") }}</p>
          </template>
          <b-skeleton
            :active="isLoading"
            size="is-large"
            width="80%"
          ></b-skeleton>

          <div class="level info is-mobile">
            <div class="level-item is-justify-content-flex-start">
              <template v-if="!isLoading">
                {{ categoriesProps(item, 1) }}
              </template>
              <b-skeleton
                :active="isLoading"
                size="is-large"
                width="70%"
              ></b-skeleton>
            </div>
            <div class="level-item">
              <template v-if="!isLoading">
                {{ categoriesProps(item, 2) }}
              </template>
              <b-skeleton
                :active="isLoading"
                position="is-centered"
                size="is-large"
                width="70%"
              ></b-skeleton>
            </div>
            <div class="level-item is-justify-content-flex-end">
              <template v-if="!isLoading && hideCurrentBid == false">
                <div class="is-block is-relative">
                  <div class="text-tag is-size-7">
                    <b-tooltip
                      :label="
                        item.currentBid > 0
                          ? $t('home.widget.box.highestBid')
                          : $t('home.widget.box.noBidsRegistered')
                      "
                      position="is-left"
                      size="is-small"
                    >
                      {{ $t("home.widget.box.bid") }}
                    </b-tooltip>
                  </div>
                  <span v-if="item.currentBid > 0"
                    >{{ item.currentBid | numFormat("0,0") }} kr</span
                  ><span v-else>{{ $t("home.widget.box.noBids") }}</span>
                </div>
              </template>
              <b-skeleton
                :active="isLoading"
                position="is-right"
                size="is-large"
                width="70%"
              ></b-skeleton>
            </div>
          </div>

          <div class="level is-mobile is-relative">
            <div class="level-item is-justify-content-flex-start">
              <div class="is-block">
                <template v-if="!isLoading && item.readyForSaleDate > 0">
                  <div class="text-tag mt-2">
                    <b-tooltip
                      :label="`${$t('home.widget.box.auctionDay')}`"
                      position="is-right"
                      size="is-small"
                    >
                      <b>{{ $t("home.widget.box.auctionDay") }}</b
                      ><br />
                      {{ getFormattedDateTime(item.readyForSaleDate, "LL") }}
                    </b-tooltip>
                  </div>
                </template>
                <b-skeleton
                  :active="isLoading"
                  width="7em"
                  size="is-large"
                ></b-skeleton>
              </div>
            </div>
            <div class="level-item is-justify-content-flex-end is-size-7">
              <template v-if="!isLoading"
                ><b-tag>ID {{ item.id }}</b-tag></template
              >
              <b-skeleton
                :active="isLoading"
                width="5em"
                position="is-right"
                size="is-small"
              ></b-skeleton>
              <b-tooltip
                :label="
                  `${$t('home.widget.box.youAreCurrentlyLeadingBidding')}`
                "
              >
                <b-tag
                  size="is-small"
                  type="is-success"
                  class="ml-1"
                  v-if="item.leadingAuction"
                  >{{ $t("home.widget.box.yourBid") }}</b-tag
                >
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
    </article>
  </router-link>
</template>

<script>
import helpers from "../../../helpers";
export default {
  props: {
    item: {
      type: [Object, Number],
      default: function() {
        return {
          id: 0
        };
      }
    },
    isLoading: Boolean,
    size: {
      Type: Number,
      default: 7
    },
    hideCurrentBid: {
      Type: Boolean,
      default: false
    }
  },

  mixins: [helpers],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: 1em;
  padding: 0.5em;

  &:hover {
    background: #efefef;
  }

  .is-ellipsis {
    @media screen and (max-width: $tablet) {
      white-space: unset;
    }
  }

  .media-content {
    div:nth-of-type(3) .b-skeleton-item {
      margin-top: 0.9em;
    }
  }

  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: $tablet) {
      align-items: flex-start;
      margin-top: 0.5em;
    }

    img,
    .b-skeleton-item {
      border-radius: 0.5em;

      height: 155px;
      width: 230px;

      @media screen and (max-width: $tablet) {
        height: 70px;
        width: 95px;
      }
    }
  }

  .level.info {
    .level-item {
      font-weight: 700;

      @media screen and (max-width: $tablet) {
        font-weight: 600;
      }

      .text-tag {
        font-weight: 300;
        position: absolute;
        right: 0;
        top: -10px;

        .tooltip-content {
          z-index: 9999;
        }
      }
    }
  }
}
</style>
